import { Button, Grid } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { gridSizeMdLg12 } from '@/shared';
import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { SampleTable } from '@/shared/components/ui';
import { MRT_ColumnDef } from 'material-react-table';

export type SelectSeriesModalProps = {
    open: boolean;
    data: any[];
    setOpen: (open: boolean) => void;
    activityIndex: number;
    equipmentIndex: number;
    form: any;
};

const SelectSeriesModal: React.FC<SelectSeriesModalProps> = ({
    open,
    data,
    setOpen,
    activityIndex,
    equipmentIndex,
    form
}) => {

    const handleClose = () => {
        setOpen(false);
    };

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                header: "Acciones",
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => addSerie(row)}
                        >
                            Seleccionar
                        </Button>
                    );
                },
            },
            {
                header: "Serie",
                accessorKey: "serie",
                size: 200,
            },
        ],
        []
    );

    const addSerie = (row: any) => {
        // validar si ya fue egregado
        const seriesAgregadas = form.getValues(`activitiesOrder.${activityIndex}.equipmentUsed`);
        const validador = seriesAgregadas.some(
            (serie: any) => serie.seriesProductUsed === row.original.serie
        );

        if (validador) {
            toast.error("La serie ya fue seleccionada");
            return;
        }

        const name = `activitiesOrder.${activityIndex}.equipmentUsed.${equipmentIndex}.seriesProductUsed` as const;
        form.setValue(name, row.original.serie, {
            shouldDirty: true,
            shouldValidate: true,
        });
        toast.success("Serie seleccionada correctamente");
        setOpen(false);
    }

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Seleccionar Serie"}
                width="100%"
                contentNode={
                    <>
                        <Grid container spacing={3}>
                            <Grid item {...gridSizeMdLg12}>
                                <SampleTable
                                    columns={columns}
                                    data={data} />
                            </Grid>
                        </Grid>
                    </>
                }
                onClose={handleClose}
            />
        </>
    );
}

export default SelectSeriesModal;